import { get } from 'lodash';
import { makeOptionsData } from 'Common/FormHelper';
import { createSelector } from 'reselect';

const root = state => get(state, 'IdCardsState.IdCards');

export const getTeachers = state => get(root(state), 'teachers', []);
export const getLoading = state => get(root(state), 'fetching');
export const getReport = state => get(root(state), 'report');
export const getFetchError = state => get(root(state), 'fetchError');
export const getGrades = state => get(root(state), 'grades', []);
export const getGradeOptions = createSelector(
  getGrades,
  grades => {
    const gradeOptions = makeOptionsData(grades, {
      keyKey: 'Id',
      valueKey: 'Id',
      textKeys: ['Id'],
    });
    gradeOptions.unshift({
      value: 'ALL',
      text: 'ALL',
      key: 'ALLGrades',
    });
    return gradeOptions;
  }
);



// WEBPACK FOOTER //
// ./src/pages/idcards/state/selector.js